import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import styles from './VbUiSidebar.Component.module.less';
import { SidebarNotification } from '../sidebarLayout/SidebarNotification';

@Component({
	selector: 'vb-ui-sidebar-notification',
	imports: [CommonModule],
	template: `
		@if(notification?.count > 0) {
			<span
				[ngClass]="styles.notificationCount">
				{{ notification.count > 99 ? '99+' : notification.count }}
			</span>
		}
		@else if(notification?.showIcon) {
			<span class="glyphicons bell"
				[ngClass]="styles.notificationIcon"></span>
		}
	`
})
export class VbUiSidebarNotificationIconComponent {
	@Input() public notification: SidebarNotification;
	public readonly styles = styles;


}
